import { transparentize } from 'color2k';
import styled from 'styled-components';
import { Colors } from 'styles';
import { rootTheme } from 'theme/rootTheme';

const TextArea = styled.textarea`
  all: unset;
  border-radius: ${rootTheme.radius.xs}px;
  background-color: ${Colors.accountInputBackground};
  border: 1px solid ${transparentize(Colors.white, 0.92)};
  padding: 15px;
  min-height: 20px;
  height: 40px;
  &:focus {
    border-color: ${Colors.blue3};
    outline: 0;
  }
`;

export default TextArea;
